import React from "react";

import { ShopForm } from "pages/shopManager/ShopForm";
import { createShop } from "shared/api/ShopApi";

// 등록 폼 초기값(빈 값). 모듈 상수로 둬 ShopForm이 1회만 초기화하도록 안정 참조 유지.
const EMPTY_INITIAL = {
  name: "",
  title: "",
  category: "",
  content: "",
  engTitle: "",
  engContent: "",
  pin: false,
  inProgress: true, // 신규 제휴는 기본 '제휴중'
  image: "",
};

function ShopDataRegister() {
  return (
    <ShopForm
      mode="create"
      initialValues={EMPTY_INITIAL}
      onSubmit={(data) => createShop(data)}
    />
  );
}

export default ShopDataRegister;
